export const PROJECT_REQUEST_LIST_PAGE_TYPE = {
  PORTFOLIO: 'PORTFOLIO'
};
